import React, { FC } from 'react';

export const FormGroup: FC = ({ children }) => (
  <div className="modal__form__group">{children}</div>
);
